import { render, staticRenderFns } from "./SalesFreightOrder.vue?vue&type=template&id=5d53a33e&scoped=true&"
import script from "./SalesFreightOrder.vue?vue&type=script&lang=js&"
export * from "./SalesFreightOrder.vue?vue&type=script&lang=js&"
import style0 from "./SalesFreightOrder.vue?vue&type=style&index=0&id=5d53a33e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d53a33e",
  null
  
)

export default component.exports